import { Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const CustomerOnly = ({ component: Component, ...props }) => {

    const { isCustomer } = useAuth();

    if (!isCustomer) return <Navigate to="/app/crm" replace />

    return <Component {...props} />
};

export default CustomerOnly;